import { API_BASE_URL } from '../utils/constants';
import { setupAxiosInterceptor } from '../utils/axiosInterceptor';

// Setup axios interceptor on module load - COMMENTED OUT (auto-logout disabled)
// setupAxiosInterceptor();

interface LoginResponse {
  success: boolean;
  message: string;
  data: {
    user: {
      id: string;
      firstName: string;
      lastName: string;
      nni: string;
      phoneNumber: string;
      availableBalance: number;
      userType: string;
      username: string;
      password: null;
      bankName: string | null;
      createdById: string | null;
    };
    token: string;
  } | null;
}

export const login = async (username: string, password: string): Promise<LoginResponse> => {
  try {
    console.log('Attempting login to:', `${API_BASE_URL}/auth/login`);
    console.log('With credentials:', { username, password: '***' });
    
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    
    console.log('Response status:', response.status);
    
    // Handle non-200 responses
    if (!response.ok) {
      let errorMessage = `Login failed with status ${response.status}`;
      try {
        const errorData = await response.json();
        console.log('Error response:', errorData);
        errorMessage = errorData.message || errorData.error || errorMessage;
      } catch (e) {
        const errorText = await response.text();
        console.log('Error text:', errorText);
        errorMessage = errorText || errorMessage;
      }
      return { success: false, message: errorMessage, data: null };
    }
    
    const data: LoginResponse = await response.json();
    console.log('✅ Login response received:', data);
    
    return data;
  } catch (error: any) {
    console.error('Login error:', error);
    return { success: false, message: error.message || 'Network error occurred', data: null };
  }
};

export const logout = () => {
  localStorage.clear();
  // Redux state will be cleared by the component
  window.location.href = '/login';
};

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('token');
};

export const getAuthHeader = (): Record<string, string> => {
  const token = localStorage.getItem('token');
  if (token) {
    return { 'Authorization': `Bearer ${token}` };
  }
  return {};
};

